export default __webpack_public_path__ + "static/media/LaTerangaB.3b9d065b.png";